import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveMapMotion } from "../services/motionServices";

export function useMotionMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: saveMapMotion,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['motions'] });
      qc.invalidateQueries({ queryKey: ['statistics'] });
    },
  });
}